import { Link } from "react-router-dom";
import { buttonVariants } from "../../components/ui/button";
import { useUpcomingAppointments } from "../../lib/hooks/doctors/use-upcoming-appointments";
import { format, isAfter } from "date-fns";

function UpcomingAppointments({
  selectedPatient,
}: {
  selectedPatient: string | null;
}) {
  const { appointments = [] } = useUpcomingAppointments({
    selectedPatient,
  });

  const appointmentList = Array.isArray(appointments) ? appointments : [];
  
  const now = new Date();
  const futureAppointments = appointmentList.filter((apmt) => {
    const startTime = new Date(apmt?.startTime);
    const status: string = apmt?.isConsultationCompleted;
    return isAfter(startTime, now) && status !== "COMPLETED";
  });
  if (!futureAppointments.length) return null;

  return (
    <div className="mt-4">
      <h2 className="mb-2 font-bold sm:mb-4 sm:text-lg">
        Upcoming Appointments
      </h2>
      <div className="grid gap-4 sm:grid-cols-2 md:gap-6 xl:grid-cols-3">
        {futureAppointments.map((apmt) => {
          //console.log(apmt)
          const appointmentDate = apmt?.startTime;
          const dayOfWeek = appointmentDate
            ? format(new Date(appointmentDate), "EEEE")
            : "";
          const startTime = apmt?.startTime
            ? format(new Date(apmt.startTime), "hh:mm a")
            : "";
          const endTime = apmt?.endTime
            ? format(new Date(apmt.endTime), "hh:mm a")
            : "";

          return (
            <div
              key={apmt.bookingId}
              className="rounded-lg border-4 border-primary bg-white p-5 text-primary"
            >
              <h2 className="mb-2 text-sm font-bold md:text-xl">
              {startTime} - {endTime},{" "} 
              {dayOfWeek.slice(0, 3)},{" "}
              {format(new Date(apmt.appointmentDate), "dd MMM yyyy")}
                
              </h2>
              <p className="text-sm font-bold md:text-lg">
                Dr {apmt.doctorName}
              </p>
              <p className="text-xs text-black font-bold opacity-60 sm:text-sm">General Physician</p>
              <div className="mt-3 flex items-center justify-between gap-2">
                <p className="max-md:text-xs">For {apmt.patient.name}</p>
                  <div className="flex gap-2">
                  <Link
                    to={`/appointment/${apmt.bookingId}`}
                    className={buttonVariants({
                      className: "max-sm:h-[26px] max-sm:text-[11px]",
                      size: "sm",
                      variant: "default",
                      
                    })
                  }
                  >
                    Details
                  </Link>
                  <a
  target="_blank"
  rel="noreferrer"
  href={`https://www.google.com/maps/search/?api=1&query=${apmt.branchDetails?.[0]?.latitude ?? 0.000000},${apmt.branchDetails?.[0]?.longitude ?? 0.000000}`}
  className={buttonVariants({
    className: "max-sm:h-[26px] max-sm:text-[11px]",
    size: "sm",
    variant: "secondary",
  })}
>
<span className="flex items-center">
  Directions
  <svg
    className="ml-2 h-5 w-5" // Tailwind utility classes for size
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 20V18.6C4 15.2397 4 13.5595 4.65396 12.2761C5.2292 11.1471 6.14708 10.2292 7.27606 9.65396C8.55953 9 10.2397 9 13.6 9H20M20 9L15 14M20 9L15 4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
</span>

</a>

                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default UpcomingAppointments;
